import publicRoutes from '../Public/Routes';
import cfdiRoutes from '../Cfdi/Routes';

export default [
	...publicRoutes,
	...cfdiRoutes
];